export default {
  title: 'Programme de fidélité',
};
